import { Eye, Printer } from 'react-feather';
import PageLayout from '../../../components/PageLayout';
import {
  formatCurrency,
  formatCurrencyV2,
  formatDate,
  getItemById,
  getQueryString,
  limitOptions,
  makeDropdownOptions,
  OPTIONS,
} from '../../../utils/common.util';
import useSWR from 'swr';
import { useState } from 'react';
import PaymentsReportsModal from './PaymentsReportsModal';
import {
  DatePicker,
  DatePickerInput,
  Pagination,
  Select,
  SelectItem,
} from 'carbon-components-react';
import PrintOutHead from '../../../components/PrintOutHead';
import { PrintView } from '../../../components/PrintView/print-view.component';
import CustomButton from '../../../components/custom-button/custom-btn.component';
import { useUrlState } from '../../../utils/useUrlState';
import Combobox from '../../../components/combobox/Combobox';
import { useDebounceState } from '../../../utils/useDebounceState';

const initialData = {
  dateFrom: '',
  dateTo: '',
  schoolId: '',
  paymentMethod: '',
  status: '',
  skip: 0,
  take: 10,
};

export default function CashReceivedSchoolsReport() {
  const [isOpen, setIsOpen] = useState('');
  const [query, setQuery] = useUrlState(initialData);

  const [searchSchool, setSearchSchool] = useDebounceState('');
  const { data: schools, isLoading: isLoadingSchools } = useSWR(
    `school/list/v2?${getQueryString({
      query: searchSchool,
      schoolType: 'REGULAR',
    })}`,
  );

  const { data, isLoading, error } = useSWR(
    `school/invoice-payment-report?${getQueryString(query)}`,
  );

  // const entries = dailySummaryData?.entries ?? [];
  const entries = data?.response ?? [];

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Admin', to: '/admin' },
        { label: `Cash Received Schools Report`, active: true },
      ]}
      title={
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: '30px' }}
        >
          <h1 className="h-20">Cash Received Schools Report</h1>{' '}
          <button
            className="text-12 text-primary d-flex align-items-center font-bold pointer clean-btn "
            style={{ gap: '4px' }}
            onClick={() => setIsOpen('reports')}
          >
            <Eye size="14" strokeWidth="2px" />
            <span>VIEW OTHER REPORTS</span>
          </button>
        </div>
      }
      isLoading={isLoading}
    >
      {/* FILTERS  */}
      {/* <p className="mt-20 text-12">
        Select at least a start and end dates to show report.
      </p> */}
      <div className="mt-10 card-row-4">
        <Combobox
          options={schools ?? []}
          label="School"
          value={
            query.schoolId
              ? schools?.find((s) => s.id === Number(query.schoolId))
              : null
          }
          onChange={(option) => {
            setQuery({ schoolId: option ? option.id : '' });
            setSearchSchool('');
          }}
          onSearch={setSearchSchool} // The combobox now just updates the search term state
          onClear={() => {
            setQuery({ schoolId: '' });
            setSearchSchool('');
          }}
          loading={isLoadingSchools} // Pass the loading state down
          renderSelected={(option) => `${option.name}`}
          renderOption={(option) => `${option.name}`}
          labelKey="fullName"
          valueKey="id"
          searchPlaceholder="Search schools..."
          placeholder=""
        />
        <DatePicker
          dateFormat="Y-m-d"
          datePickerType="single"
          id="start-date-picker"
          maxDate={new Date().toISOString().split('T')[0]}
          onChange={(value) => {
            if (value.length > 0) {
              setQuery({
                dateFrom: [
                  value[0].getFullYear(),
                  ('0' + (value[0].getMonth() + 1)).slice(-2),
                  ('0' + value[0].getDate()).slice(-2),
                ].join('-'),
              });
            } else setQuery({ dateFrom: '' });
          }}
          onClose={(value) => {}}
        >
          <DatePickerInput
            className="start-date"
            id="start-date"
            name="dateFrom"
            labelText="Start Date"
            value={query.dateFrom}
            max={new Date().toISOString().split('T')[0]}
            // pattern="d{1,2}/d{4}"
            pattern="\d{4}-\d{2}-\d{2}"
            autoComplete="off"
            placeholder="YYYY-MM-DD"
            type="text"
            onChange={(e) => setQuery({ dateFrom: e.target.value })}
          />
        </DatePicker>
        <DatePicker
          dateFormat="Y-m-d"
          datePickerType="single"
          id="end-date-picker"
          // minDate={
          //   new Date(query.dateFrom ?? '').toISOString().split('T')[0]
          // }
          maxDate={new Date().toISOString().split('T')[0]}
          onChange={(value) => {
            if (value.length > 0) {
              setQuery({
                dateTo: [
                  value[0].getFullYear(),
                  ('0' + (value[0].getMonth() + 1)).slice(-2),
                  ('0' + value[0].getDate()).slice(-2),
                ].join('-'),
              });
            } else setQuery({ dateTo: '' });
          }}
          onClose={(value) => {}}
        >
          <DatePickerInput
            className="end-date"
            id="end-date"
            name="dateTo"
            labelText="End Date"
            value={query.dateTo}
            max={new Date().toISOString().split('T')[0]}
            // pattern="d{1,2}/d{4}"
            pattern="\d{4}-\d{2}-\d{2}"
            autoComplete="off"
            placeholder="YYYY-MM-DD"
            type="text"
            onChange={(e) => setQuery({ dateTo: e.target.value })}
          />
        </DatePicker>
        <Select
          labelText="Payment Mode"
          onChange={(e) => setQuery({ paymentMethod: e.target.value })}
          value={query.paymentMethod}
        >
          <SelectItem value="" text="All" />
          {makeDropdownOptions(['CHEQUE', 'PAYSTACK'])?.map((mode) => (
            <SelectItem key={mode.value} value={mode.value} text={mode.label} />
          ))}
        </Select>
        <Select
          labelText="Status"
          onChange={(e) => setQuery({ status: e.target.value })}
          value={query.status}
        >
          <SelectItem value="" text="All" />
          {makeDropdownOptions(OPTIONS.completed)?.map((status) => (
            <SelectItem
              key={status.value}
              value={status.value}
              text={status.label}
            />
          ))}
        </Select>
      </div>

      <div className="mt-20">
        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
        {entries?.length > 0 && (
          <>
            <PrintOutHead
              title={`Cash Received Schools Report`}
              headings={[
                {
                  label: 'School',
                  value: getItemById(schools, query.schoolId)?.name ?? 'All',
                },
                {
                  label: 'Status',
                  value: query.status ?? 'All',
                },
                {
                  label: 'Payment Mode',
                  value: query.paymentMethod ?? 'All',
                },
                {
                  label: 'Date Range',
                  value: query.dateFrom
                    ? `${formatDate(query.dateFrom)} - ${formatDate(
                        query.dateTo,
                      )} `
                    : '-',
                },
              ]}
            />
            <PrintView>
              <div
                className="mt-30 mb-10 "
                style={{
                  display: 'flex',
                  gap: '30px',
                }}
              >
                <div>
                  Total Amount Paid:{' '}
                  <span className="font-bold">
                    {formatCurrencyV2(data?.totalAmountPaid)}
                  </span>
                </div>
                <div>
                  Total Amount Pending:{' '}
                  <span className="font-bold">
                    {formatCurrencyV2(data?.totalAmountPending)}
                  </span>
                </div>
                <div>
                  Overall Total Amount:{' '}
                  <span className="font-bold">
                    {formatCurrencyV2(data?.overallTotalAmount)}
                  </span>
                </div>
              </div>
              <div style={{ overflow: 'auto' }}>
                <table className="bx--data-table table-white">
                  <thead>
                    <tr>
                      <th>Transaction Date</th>
                      <th>Customer Name</th>
                      <th>Customer Email</th>
                      <th>Academic Year</th>
                      <th>Term</th>
                      <th>Receipt Number</th>
                      <th>Invoice Number</th>
                      <th>Amount (GH₵)</th>
                      <th>Status</th>
                      <th>Payment Mode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries.map((entry) => {
                      return (
                        <tr key={entry.invoice.subscription.epobsAccountId}>
                          <td>{formatDate(entry.createdAt)}</td>
                          <td>{entry.invoice.subscription.epobsAccountName}</td>
                          <td>{entry.emailAddress}</td>
                          <td>{entry?.academicYear}</td>
                          <td>{entry?.term}</td>
                          <td>{entry.id}</td>
                          <td>{entry.invoice.invoiceNumber}</td>
                          <td>{formatCurrency(entry.amount)}</td>
                          <td>{entry.status}</td>
                          <td>{entry.paymentMode}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </PrintView>
            <Pagination
              backwardText="Previous page"
              forwardText="Next page"
              page={Number(query.skip) + 1}
              pageNumberText="Page Number"
              pageSize={Number(query.take)}
              pageSizes={limitOptions(data?.paginationInfo?.totalCount)}
              totalItems={data?.paginationInfo?.totalCount}
              onChange={(value) =>
                setQuery({ skip: value.page - 1, take: value.pageSize })
              }
            />
          </>
        )}
        {entries?.length === 0 && (
          <p className="text-14 mt-30 text-grey">No data available.</p>
        )}

        {entries?.length > 0 && (
          <div
            className="mt-30"
            style={{
              display: 'flex',
              justifySelf: 'end',
              gap: '20px',
              alignItems: 'center',
            }}
          >
            <CustomButton classes="secondary" onClick={() => window.print()}>
              <Printer size="16" strokeWidth="2px" /> &nbsp; Print
            </CustomButton>
          </div>
        )}
      </div>

      <PaymentsReportsModal
        isOpen={isOpen === 'reports'}
        closeModal={() => setIsOpen('')}
      />
    </PageLayout>
  );
}
